module.exports = "//static.hsappstatic.net/LoginUI/static-1.14728/img/google-logo.png"